import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function CTABanner() {
  return <section id="cta" className="relative w-full py-24 px-6 overflow-hidden" data-id="element-90">
      {/* Gradient background */}
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(135deg, #0D0B2E 0%, #1A1452 30%, #6C5CE7 70%, #C850C0 100%)'
    }} data-id="element-91" />


      {/* Noise texture */}
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\")"
    }} data-id="element-92" />


      <motion.div className="relative z-10 max-w-3xl mx-auto text-center" initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.6
    }} data-id="element-93">

        <span className="text-white/60 text-xs font-semibold tracking-[0.2em] uppercase block mb-4" data-id="element-94">
          Get started
        </span>
        <h2 className="text-3xl sm:text-5xl font-bold text-white tracking-tight mb-6" data-id="element-95">
          Get something built today
        </h2>
        <p className="text-white/60 text-lg mb-10 max-w-xl mx-auto" data-id="element-96">
          Join manufacturing teams who replaced their legacy ERP with software
          that actually works for them.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-97">
          <a href="https://calendly.com/alex-thruline/learn-about-thruline" className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-navy font-semibold text-sm hover:bg-white/90 transition-all hover:shadow-lg hover:shadow-white/10" data-id="element-98">

            Get a Demo
            <ArrowRightIcon className="w-4 h-4" data-id="element-99" />
          </a>
        </div>
      </motion.div>
    </section>;
}